import NumberFormat from "react-number-format";
import FieldRequired from "./FieldRequired";
import { toast } from "react-toastify";

const AmountInput = ({errors, touched, values, setFieldValue, onBlur, value, fixedAmount, setFieldError}) => {

    return (
      <div className="flex-item width-12 mb-4">
        <div className="FormFieldGroup" data-qa="FormFieldGroup-email">
          <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
            <label htmlFor="email">
              <span className="Text Text-color--gray600 Text-fontSize--15 Text-fontWeight--500">
                Ödeme Tutarı
              </span>
            </label>
            {errors.amount ? <FieldRequired /> : null}
          </div>
          <div className="FormFieldGroup-Fieldset" id="email-fieldset">
            <div className="FormFieldGroup-container">
              <div className="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop FormFieldGroup-childBottom">
                <div className="FormFieldInput">
                  <div className="CheckoutInputContainer">
                    <span className="InputContainer" >
                      <NumberFormat
                        thousandSeparator={true}
                        decimalSeparator={"."}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={false}
                        defaultValue={value}
                        onValueChange={(val) => {
                          const inputAmount = parseFloat(val.value); // value: raw numeric string, örn. "1234.56"
                          const limitAmount = parseFloat(fixedAmount);
                          if (inputAmount > limitAmount) {
                            setFieldError(`Tutar ${limitAmount.toLocaleString()} TL'yi aşamaz.`);
                            toast.error(`Tutar ${limitAmount.toLocaleString()} TL'yi aşamaz.`);
                          }
                          else {
                            setFieldError("");
                          }
                          setFieldValue("amount", val.formattedValue)
                        }}
                        onBlur={onBlur}
                        className={`CheckoutInput Input Input--empty ${errors.amount ? "CheckoutInput--invalid" : ""}`}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  export default AmountInput;